import { Link } from 'react-router-dom';
import { products } from '@/mocks/baoyu';

export default function ProductsSection() {
  const featuredProducts = products.slice(0, 4);

  return (
    <section className="py-20 md:py-28 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-16">
          <p className="text-sm text-primary-500 font-semibold tracking-wider mb-3">产品家族</p>
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-950">探索 baoyu 全系列</h2>
          <p className="mt-4 text-foreground-600 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
            从旗舰到青春版，baoyu 为每一位用户准备了最适合的选择
          </p>
        </div>

        <div data-product-shop className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {featuredProducts.map((product, index) => (
            <Link
              key={product.id}
              to={`/category/${product.category}`}
              className="group bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden transition-all duration-300 hover:border-background-300/60 cursor-pointer"
              style={{ animation: `fadeInUp 0.5s ease-out ${index * 0.1}s both` }}
            >
              <div className="relative w-full aspect-[4/3] overflow-hidden">
                <img
                  src={product.image}
                  alt={product.name}
                  title={`${product.name} - baoyu 产品`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-5">
                <h3 className="text-base font-semibold text-foreground-950 mb-1.5">{product.name}</h3>
                <p className="text-xs text-foreground-600 leading-relaxed mb-3 line-clamp-2">{product.description}</p>
                <div className="flex flex-wrap gap-1.5 mb-3">
                  {product.features.map((f) => (
                    <span
                      key={f}
                      className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-900 text-xs whitespace-nowrap"
                    >
                      {f}
                    </span>
                  ))}
                </div>
                <div className="flex items-center gap-1.5">
                  <div className="flex items-center gap-0.5">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i
                        key={i}
                        className={`text-xs ${i < Math.floor(product.rating) ? 'ri-star-fill text-amber-400' : 'ri-star-line text-foreground-400'}`}
                      ></i>
                    ))}
                  </div>
                  <span className="text-xs text-foreground-600">{product.rating}</span>
                  <span className="text-xs text-foreground-500">({product.reviewCount.toLocaleString()})</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category/all"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-background-300/60 text-foreground-700 text-sm font-medium transition-all duration-200 whitespace-nowrap hover:border-primary-500 hover:text-primary-500 cursor-pointer"
          >
            查看全部产品
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}